import { getImgixUrl } from '../../../utils/helper';

export const createSliderImages = dataObj => {
  const productImages = dataObj.images.map(image => {
    return {
      name: image.name,
      src: image.path,
      width: image.width,
      height: image.height
    };
  });

  const lifeStyleImages = dataObj.frame.lifestyles.map(image => {
    return {
      name: `lifestyle-image-${image.id}`,
      src: image.image,
      width: image.width,
      height: image.height
    };
  });

  const imagesArr = [
    ...productImages,
    // Don't show dimensions image when it doesn't exists
    ...(dataObj.frame.dimensions_image !== ''
      ? [
          {
            name: 'dimensions',
            src: dataObj.frame.dimensions_image,
            width: dataObj.frame.dimensions_image_width,
            height: dataObj.frame.dimensions_image_height
          }
        ]
      : []),
    // Don't add fabric image for products without fabric
    ...(dataObj.fabric !== null && !dataObj?.fabric?.treatment?.id == 2
      ? [
          {
            name: 'fabric product',
            src: getImgixUrl(dataObj.fabric.image),
            width: dataObj.fabric.image_width,
            height: dataObj.fabric.image_height
          }
        ]
      : []),
    ...lifeStyleImages
  ];

  return imagesArr;
};

export const getDescriptionForHeader = product => {
  let fabricStr = '';
  if (product.fabric) {
    fabricStr = product.fabric.name;
  }

  let frameStr = '';
  if (product.frame) {
    frameStr = product.frame.name;
  }

  return `Shop the ${fabricStr} ${frameStr} at The Inside. Made-to-order just for you in 1-3 weeks, with 30-day returns. Customize your ${frameStr} to fit your style today.`;
};

const marketPlaceCategories = [28, 30, 31, 32, 33];

export const getTitleForHeader = product => {
  let fabricStr = '';
  if (product.fabric) {
    fabricStr = product.fabric.name;
  }

  let productName = '';
  if (product.name) {
    productName = product.name.substring(0, product.name.lastIndexOf('|') + 1);
  }

  const isFrameFurnitureType = product?.frame?.type?.id == 1;

  const upholsteredText = isFrameFurnitureType ? 'Upholstered Custom' : ``;
  const fabricName = isFrameFurnitureType ? fabricStr : '';

  return `${fabricName} ${upholsteredText} ${productName} The Inside Furniture`;
};

export const getPDPMessage = productData => {
  // const subcategoryId = parseInt(productData?.frame?.primarySubcategory?.id);
  // const frameId = parseInt(productData?.frame?.id);

  // if ([124, 48, 46, 297].includes(subcategoryId)) {
  //   return "Due to high demand, this product has an estimated ship window of 18-20 weeks. We're closely monitoring and will update this as soon as possible.";
  // }

  // if ([78, 80, 83, 387, 388].includes(frameId)) {
  //   return `Due to high demand, this product has an estimated ship window of 6-10 weeks. We're closely monitoring and will update this as soon as possible.`;
  // }

  // if ([151].includes(frameId)) {
  //   return `Due to high demand, this item will now ship in 8-12 weeks. We’re closely monitoring and will update this as soon as possible.`;
  // }

  //American Leather
  // if (
  //   supplierId === 18 &&
  //   !fabricsPTMHomtexAndAmericanLeather.some(x => x === fabricId)
  // ) {
  //   return `Our sofa manufacturer will be closed for two weeks during the holidays. As a result, your sofa order will now ship in 5-6 weeks instead of our standard 3-4 weeks. Happy holidays!`;
  // }

  return false;
};
